export const isDevelopment = process.env.NODE_ENV === 'development';
export const WS_PROTOCOL = isDevelopment ? "ws" : "wss";
